import React from "react";
import styled from "styled-components";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { _Button } from "../common/styled-buttons";
import { svgAsPngUri } from "save-svg-as-png";

import {
  uploadDataUri,
  uploadSvg,
  uploadJson,
} from "../../core/firebase/actions";
import shortid from "shortid";

import { modalActions } from "../../core/modal";
import { UPLOAD_CHART_MODAL } from "../modal/modal-types";

import { googleUrlShortener } from "../../core/utils";
import { getCheckoutUrl, getRootsGiftsCheckoutUrl } from "../../core/shopify";
import theme from "../../styles/theme";
import request from "request";
import _ from "lodash";

class Export extends React.Component {
  state = {};

  exportCharts() {
    const { showModal } = this.props;
    showModal(UPLOAD_CHART_MODAL);
    this.setState({ uploads: {} });

    const lowSettings = {
      scale: 0.5,
      backgroundColor: "#fff",
      encoderType: "image/jpeg",
      encoderOptions: 0.95,
    };

    const highSettings = {
      scale: 3.8,
      backgroundColor: "#fff",
      encoderType: "image/jpeg",
      encoderOptions: 0.95,
    };

    setTimeout(() => {
      const {
        uploadDataUri,
        interfaceMode,
        json,
        showModal,
        generations,
      } = this.props;

      const chartId = shortid.generate();
      const svg = document.querySelector(".fanchart svg svg");
      const svgFilepath = `svg/${chartId}.svg`;
      const jsonFilepath = `json/${chartId}.json`;
      const lowFilepath = `previews/${chartId}.jpg`;
      const highFilepath = `high-res/${chartId}.jpg`;

      const _json = {
        ...json,
        cells: {
          cells: json.cells.cells.slice(0, Math.pow(2, json.chart.generations)),
        },
      };

      if (interfaceMode === "rootsgifts") {
        svgAsPngUri(svg, lowSettings, (lowUri) => {
          uploadDataUri(lowUri, lowFilepath, (lowUrl) => {
            showModal(UPLOAD_CHART_MODAL, { progress: 50 });
            googleUrlShortener(lowUrl, (googleUrl) => {
              const previewId = googleUrl.substr(-17);
              const apiUrl =
                "https://admin.rootsgifts.com/api/svg/" + previewId;
              request.post(
                { url: apiUrl, body: svg.outerHTML, withCredentials: false },
                (err, resp) => {
                  if (err) {
                    console.log(err);
                  } else {
                    const checkoutUrl = getRootsGiftsCheckoutUrl(previewId);
                    window.location = checkoutUrl;
                  }
                }
              );
            });
          });
        });
      } else {
        uploadJson(_json, jsonFilepath, (jsonUrl) =>
          googleUrlShortener(jsonUrl, (jsonGoogleUrl) => {
            showModal(UPLOAD_CHART_MODAL, { progress: 20 });
            uploadSvg(svg.outerHTML, svgFilepath, (svgUrl) =>
              googleUrlShortener(svgUrl, (svgGoogleUrl) => {
                showModal(UPLOAD_CHART_MODAL, { progress: 40 });
                svgAsPngUri(svg, lowSettings, (lowUri) => {
                  uploadDataUri(lowUri, lowFilepath, (lowUrl) =>
                    googleUrlShortener(lowUrl, (lowGoogleUrl) => {
                      showModal(UPLOAD_CHART_MODAL, { progress: 50 });
                      svgAsPngUri(svg, highSettings, (highUri) => {
                        uploadDataUri(highUri, highFilepath, (highUrl) =>
                          googleUrlShortener(highUrl, (highGoogleUrl) => {
                            const checkoutUrl = getCheckoutUrl(
                              {
                                json: jsonGoogleUrl,
                                svg: svgGoogleUrl,
                                low: lowGoogleUrl,
                                high: highGoogleUrl,
                              },
                              generations
                            );
                            showModal(UPLOAD_CHART_MODAL, { checkoutUrl });
                          })
                        );
                      });
                    })
                  );
                });
              })
            );
          })
        );
      }
    }, 1);
  }

  render() {
    const { isRootsGifts } = this.props;
    return (
      <_Button background={theme.primary} onClick={() => this.exportCharts()}>
        {isRootsGifts ? "Save & Add to Cart" : "Order Your Chart"}
      </_Button>
    );
  }
}

const mapStateToProps = (state, props) => ({
  generations: state.chart.generations,
  interfaceMode: state.ui.interfaceMode,
  json: {
    chart: state.chart,
    generations: state.generations,
    cells: state.cells,
  },
});

const mapDispatchToProps = Object.assign({ uploadDataUri }, modalActions);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Export));



// WEBPACK FOOTER //
// ./src/components/export/index.js